export enum AssetOriginType {
    ASSET = 'ASSET',
    ASSET_FINDING = 'ASSET_FINDING',
    ASSET_FINDING_OVERVIEW = 'ASSET_FINDING_OVERVIEW',
    ASSET_VIEW_FINDING_OVERVIEW = 'ASSET_VIEW_FINDING_OVERVIEW',
    ASSET_LANDING = 'ASSET_LANDING',
}
